import { type User } from '@prisma/client';
import type { UseDataFunctionReturn } from '~/remix';
import { useMatches } from '~/remix';
import type { loader as rootLoader } from '~/root';

export function stripPhoneNumber(phoneNumber?: string | null) {
  if (phoneNumber?.startsWith('+1')) phoneNumber = phoneNumber.substring(2);
  return phoneNumber?.replace(/\D/g, '') ?? '';
}

export function formatPhoneNumber(phoneNumber?: string | null) {
  return phoneNumber?.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3') ?? '';
}

export function formatCurrency(amount: number) {
  return `$${(amount / 100).toFixed(2)}`;
}

export function getRandom(start: number, end: number) {
  return Math.floor(Math.random() * (end - start + 1)) + start;
}

export function range(start: number, end: number, step: number = 1) {
  return Array.from(
    { length: (end - start + 1) / step },
    (_, i) => start + i * step,
  );
}

export function nodeStreamToReadableStream(nodeStream: any) {
  return new ReadableStream({
    start(controller: any) {
      nodeStream.on('data', (chunk: any) => {
        controller.enqueue(chunk);
      });
      nodeStream.on('end', () => {
        controller.close();
      });
    },
  });
}

export function useUser() {
  const matches = useMatches();
  return matches[0]?.data?.user as User;
}

export function useRootLoaderData() {
  return useMatches()[0].data as UseDataFunctionReturn<typeof rootLoader>;
}

export function getUtcNow() {
  return new Date(Date.parse(new Date(Date.now()).toISOString()));
}

export function unixTimestamp(date = Date.now()) {
  return Math.floor(date / 1000);
}

export function tryParseJson(data: string) {
  try {
    return JSON.parse(data);
  } catch {
    return data;
  }
}
